/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserDataDto } from '../../models/platform-api-result-of-user-data-dto';
import { PlatformUpdateUserAppState } from '../../models/platform-update-user-app-state';

export interface PostUserdataActionUpdateAppState$Params {
      body: PlatformUpdateUserAppState
}

export function postUserdataActionUpdateAppState(http: HttpClient, rootUrl: string, params: PostUserdataActionUpdateAppState$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserDataDto>> {
  const rb = new RequestBuilder(rootUrl, postUserdataActionUpdateAppState.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserDataDto>;
    })
  );
}

postUserdataActionUpdateAppState.PATH = '/api/userdata/action/update-app-state';
